import { isFulfilled } from "@reduxjs/toolkit";
import { format, isValid } from "date-fns";
import { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useAppDispatch } from "../../../../app/hooks";
import { isoFormat } from "../../../../common/helpers/formatDateTime";
import { NameIdOption } from "../../../../common/types/commonTypes";
import { fetchTesSalaryComponents } from "../../../tesSalaryComponents/tesSalaryComponentsSlice";
import { BULK_SALARY_INCREASE_FILTER_NAMES } from "../constants";
import { BulkSalaryIncreaseFilterValues } from "../types";
import SalaryIncreaseConfigBasic from "./SalaryIncreaseConfigBasic";
import SalaryIncreaseConfigRows from "./SalaryIncreaseConfigRows";

type Props = {
  handleExpands: (salaryComponent: string) => void;
  addExpands: (salaryComponent: string) => void;
  expands: Record<string, boolean>;
};
const SalaryIncreaseConfig = ({
  handleExpands,
  addExpands,
  expands,
}: Props) => {
  const dispatch = useAppDispatch();

  const { control, watch, setValue, getValues } =
    useFormContext<BulkSalaryIncreaseFilterValues>();

  const tes = watch(
    BULK_SALARY_INCREASE_FILTER_NAMES.TES,
  ) as NameIdOption | null;

  const salaryIncreaseStartDate = watch(
    BULK_SALARY_INCREASE_FILTER_NAMES.SALARY_INCREASE_START_DATE,
  );

  useEffect(() => {
    if (tes?.id && salaryIncreaseStartDate && isValid(salaryIncreaseStartDate))
      dispatch(
        fetchTesSalaryComponents({
          tesId: tes?.id,
          date: format(salaryIncreaseStartDate, isoFormat),
        }),
      ).then((action) => {
        if (isFulfilled(action)) {
          setValue(
            "salaryComponents",
            action.payload.map((salaryComponent) => {
              addExpands(salaryComponent.code);

              const code = salaryComponent?.code || "";
              const allValues = getValues("salaryComponents");
              const currentValue = allValues.find(
                (value) => value.code === code,
              );

              const defaultRowValues = {
                code: code,
                changeSalary: currentValue?.changeSalary || "",
                increasePercentage: currentValue?.increasePercentage || "",
                increaseAmount: currentValue?.increaseAmount || "",
              };

              return defaultRowValues;
            }),
          );
        }
      });
    // FIXME: fix this or add comment why this is needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tes, salaryIncreaseStartDate]);

  const { fields } = useFieldArray({
    control,
    rules: { required: true },
    name: "salaryComponents",
  });

  return (
    <>
      <SalaryIncreaseConfigBasic />
      <SalaryIncreaseConfigRows
        rows={fields}
        handleExpands={handleExpands}
        expands={expands}
      />
    </>
  );
};

export default SalaryIncreaseConfig;
